import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  width?: string;
  height?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'scroll-content',
  props: {
    modifires: { type: [String, Array, Boolean] },
    width: { default: "none" },
    height: { default: "none" }
  },
  setup(__props: any) {

const props = __props;

_useCssVars(_ctx => ({
  "25b8af06": (_ctx.width),
  "778e37e7": (_ctx.height)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('scroll-content', _ctx.modifires))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})